import { toast as sonner } from "sonner";

export const toast = {
  success: (message: string) => sonner.success(message),
  error: (message: string) => sonner.error(message),
  info: (message: string) => sonner.info(message),
  promise: <T>(p: Promise<T>, opts: { loading: string; success: string; error: string }) =>
    sonner.promise(p, opts),
};
